import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledGainAccessContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 90px 10px 0;
`;

export const StyledGainAccessThanksTitle = styled.h5`
  margin-bottom: 16px;
  ${setFontVariant('h5', colorsPalettes.carbon[400])};
  text-align: center;
  margin-top: 0;
`;

export const StyledGainAccessTitle = styled.h1`
  margin: 30px 0 16px;
  ${setFontVariant('h5', colorsPalettes.carbon[400])};
  font-weight: 700;
`;

export const StyledGainAccessDescription = styled.p`
  max-width: 300px;
  margin: 0 0 24px 0;
  ${setFontVariant('subsectionTitle', colorsPalettes.carbon[300])};
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.08px;
  text-align: center;
`;

export const StyledGainAccessImage = styled.img`
  height: 214px;
  margin: 45px 0 0 0;
`;

export const StyledGainAccessThanksImage = styled.img`
  width: 226px;
  height: 202px;
  margin-bottom: 24px;
`;
